import { render, staticRenderFns } from "./AutoServiceDetailHeader.vue?vue&type=template&id=66248964"
import script from "./AutoServiceDetailHeader.vue?vue&type=script&lang=js"
export * from "./AutoServiceDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports